import { createTheme } from '@mui/material/styles';

// AI Tutor color scheme applied across the app
const theme = createTheme({
  palette: {
    primary: {
      main: '#0172A6',      // Primary teal
      dark: '#015d8d',      // Darker teal for hover
      light: '#0891b2',     // Lighter teal
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#1e40af',      // Deep blue
      dark: '#1e3a8a',      // Darker blue for hover
      light: '#3b82f6',     // Lighter blue
      contrastText: '#ffffff',
    },
    success: {
      main: '#22c55e',      // Success green
      dark: '#16a34a',
      light: '#4ade80',
      contrastText: '#ffffff',
    },
    error: {
      main: '#ef4444',      // Error red
      dark: '#dc2626',
      light: '#f87171',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#f59e0b',      // Warning amber
      dark: '#d97706',
      light: '#fbbf24',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f9fafb',   // Light gray background
      paper: '#ffffff',
    },
    text: {
      primary: '#202124',   // Dark text
      secondary: '#6b7280', // Gray text
    },
    divider: '#e5e7eb',     // Border color
  },
  typography: {
    fontFamily: "'Be Vietnam Pro', 'Poppins', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // Disable uppercase transformation
          borderRadius: '8px',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
        },
      },
    },
  },
});

export default theme;
